import ContentToPublishStatusModel from '@models/website/ContentToPublishStatusModel';
import doc                         from '@widesk-core/decorators/doc';
import WebsiteServiceModel         from '@/models/WebsiteServiceModel';
import Blamable                    from '@/models/traits/Blamable';
import { Addable }                 from '@widesk-core/decorators/addable';
import { Editable }                from '@widesk-core/decorators/editable';
import { Deletable }               from '@widesk-core/decorators/deletable';
import { Timestampable }           from '@widesk-core/decorators/timestampable';

@doc.path('/content_to_publishes/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractContentToPublishModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'date[before]': id;
		'date[strictly_before]': id;
		'date[after]': id;
		'date[strictly_after]': id;
		'contentToPublishStatus': string;
		'objectUrn': Urn;
	};

	declare private _tsSorts: {
		id: string;
		date: string;
		createdAt: string;
		updatedAt: string;
	};

	declare abstract object: unknown;
	@doc.date declare date: Dayjs;
	@doc.model(ContentToPublishStatusModel)
	declare contentToPublishStatus: ContentToPublishStatusModel;
}

interface AbstractContentToPublishModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractContentToPublishModel;
